import Vue from 'vue'
import { Api } from './api'
import { Flow } from './flow'

const USER_PURPOSES = [
  {
    id: 'sell_car',
    name: 'Ich möchte mein Auto verkaufen.'
  },{
    id: 'trade_in',
    name: 'Ich bin an einer Inzahlungnahme interessiert.'
  },{
    id: 'know_price',
    name: 'Ich möchte einfach nur den Preis wissen.'
  },
];

const MONTHS = [
  {
    id: '01',
    name: 'Januar'
  },
  {
    id: '02',
    name: 'Februar'
  },
  {
    id: '03',
    name: 'März'
  },
  {
    id: '04',
    name: 'April'
  },
  {
    id: '05',
    name: 'Mai'
  },
  {
    id: '06',
    name: 'Juni'
  },
  {
    id: '07',
    name: 'Juli'
  },
  {
    id: '08',
    name: 'August'
  },
  {
    id: '09',
    name: 'September'
  },
  {
    id: '10',
    name: 'Oktober'
  },
  {
    id: '11',
    name: 'November'
  },
  {
    id: '12',
    name: 'Dezember'
  }
]

const DEFAULT_STATE = {
  step: "make",
  token: null,
  lead: null,
  widget: false,
  pristine: true,
  options: {
    purpose: null,
    make: null,
    model: null,
    year: null,
    month: null,
    bodytype: null,
    fuel: null,
    power: null,
    engine: null,
    equipment: null,
    extras: null,
    mileage: null,
    zip: null,
    location: null,
    email: null,
    valuation: null,
  },
  selected: {
    purpose: null,
    make: null,
    model: null,
    year: null,
    month: null,
    bodytype: null,
    fuel: null,
    power: null,
    engine: null,
    equipment: null,
    schwacke: null,
    extras: null,
    mileage: null,
    zip: null,
    location: null,
    email: null,
    valuation: null,
    dealerForm: null
  }
}

export const store = {
  state: JSON.parse(JSON.stringify(DEFAULT_STATE)),
  mutations: {
    reset(state) {
      Object.assign(state, JSON.parse(JSON.stringify(DEFAULT_STATE)));
      Vue.set(state, "step", "make");
    },
    updateStep(state, payload) {
      Vue.set(state, "step", payload.name)
      Vue.set(state, "pristine", false);
    },
    updateToken(state, payload) {
      Vue.set(state, "token", payload.token)
    },
    updateLead(state, payload) {
      Vue.set(state, "lead", payload.lead)
    },
    updateSelected(state, payload) {
      Vue.set(state.selected, payload.name, payload.value)
    },
    toggleOption(state, payload) {
      var options = state.selected[payload.name] || [];
      if(options.indexOf(payload.value) >= 0) {
        options.splice(options.indexOf(payload.value), 1);
      } else {
        options.push(payload.value);
      }
      Vue.set(state.selected, payload.name, options)
    },
    toggleSingleOption(state, payload) {
      Vue.set(state.selected, payload.name, payload.value)
    },
    updateOptions(state, payload) {
      
      if (payload.name === 'month' && state.selected.year) {
        return Vue.set(state.options, payload.name, MONTHS)
      }

      if (payload.name === 'purpose' && state.selected.mileage) {
        return Vue.set(state.options, payload.name, USER_PURPOSES)
      }

      Vue.set(state.options, payload.name, payload.options)
    }
  },
  actions: {
    selectOption({ commit, state }, option) {
      const needUpdate = state.selected[option.name] !== option.value;
      if (option.value) { commit('updateSelected', option); }

      const nextStepName = Flow.next(option.name)
      if(nextStepName) { commit("updateStep", nextStepName); }

      if (needUpdate && state.step != 'purpose') {
        Flow.resetSteps(option.name).forEach(function(element) {
          commit("updateOptions", {name: element.name, options: null});
          commit("updateSelected", {name: element.name, value: null});
        });
      }

      if(Flow.step(state.step).api) {
        Api.get(this, state.step);
      } else {
        commit("updateOptions", {name: state.step, options: [true]});
      }
    },
    createLead({ commit, state}) {
      Promise.all([ Api.get(this, "valuation") ])
      .then(function(res) {
        return Api.post(this, "createLead");
      }.bind(this)).catch(function(err) { console.warn(err); })
    },
    createWidgetLead() {
      Promise.all([Api.get(this, "valuation")])
      .then(function() {
        return Api.post(this, "createWidgetLead");
      }.bind(this)).catch(function(err) { console.warn(err); })
    },
    switchToWidget({ state }) {
      Vue.set(state, "widget", true);
    },
    setDealerKey({ state }, dealerKey) {
      Vue.set(state, "dealerKey", dealerKey);
    }
  }
}



// WEBPACK FOOTER //
// ./src/services/store.js